import { Edit } from '@mui/icons-material'
import { Button, Card, CardContent, Grid, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { LabelField, LockedChip } from 'components'
import { OhioBuildABoxDto } from 'dtos/ohioBuildABoxes'
import { useNavigate } from 'react-router-dom'
import { formatDateMoment } from 'utils'

interface Props {
  ohioBuildABox: OhioBuildABoxDto
}

export default function OhioBuildABoxCard({ ohioBuildABox }: Props) {
  const navigate = useNavigate()

  return (
    <Card>
      <CardContent>
        <Grid container direction='row' alignItems='flex-start' spacing={2}>
          <Grid item xs={12} sm={4} container spacing={2}>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item>
                <LockedChip isLocked={ohioBuildABox.isLocked} />
              </Grid>

              <Grid item>
                <Button color='primary' endIcon={<Edit />} onClick={() => navigate(encodeURIComponent(ohioBuildABox.ohioBuildABoxGuid!))} variant='text'>
                  MANAGE BOX
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Count' value={ohioBuildABox.ohioBuildABoxBundles.flatMap(obabb => obabb.vehicles).length} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Tracking #' value={ohioBuildABox.fedExOutboundShipment?.trackingNumber} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Box Shipped' value={formatDateMoment(ohioBuildABox.fedExOutboundShipment?.shipDateTime)} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Box Delivered' value={formatDateMoment(ohioBuildABox.fedExOutboundShipment?.deliveryDateTime)} />
            </Grid>

            <Grid item xs={12}>
              <LabelField
                label='Created'
                value={`${formatDateMoment(ohioBuildABox.createdDateTime)} by ${ohioBuildABox.createdByPerson?.firstName} ${
                  ohioBuildABox.createdByPerson?.lastName
                }`}
              />
            </Grid>

            <Grid item xs={12}>
              <LabelField
                label='Modified'
                value={`${formatDateMoment(ohioBuildABox.updatedDateTime)} by ${ohioBuildABox.updatedByPerson?.firstName} ${
                  ohioBuildABox.updatedByPerson?.lastName
                }`}
              />
            </Grid>
          </Grid>

          <Grid xs={12} sm={8}>
            <TableContainer>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>

                  <TableCell>Last 6 Of VIN</TableCell>

                  <TableCell>Importer Stock #</TableCell>

                  <TableCell>Year</TableCell>

                  <TableCell>Make</TableCell>

                  <TableCell>Model</TableCell>

                  <TableCell>Vehicle Check-In Date</TableCell>

                  <TableCell>Application Packet Ready For Build A Box</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {ohioBuildABox.ohioBuildABoxBundles.map(ohioBuildABoxBundle =>
                  ohioBuildABoxBundle.vehicles.map((vehicle, index) => (
                    <TableRow key={vehicle.vehicleGuid}>
                      {index === 0 && (
                        <TableCell align='center' rowSpan={ohioBuildABoxBundle.vehicles.length} sx={{ verticalAlign: 'middle' }}>
                          <Grid container>
                            <Grid item xs={12}>
                              <LockedChip isLocked={ohioBuildABoxBundle.isLocked} />
                            </Grid>

                            <Grid item xs={12}>
                              <Typography color='primary'>{ohioBuildABoxBundle.ohioTitleOwnerName}</Typography>
                            </Grid>
                          </Grid>
                        </TableCell>
                      )}

                      <TableCell>{vehicle.vin.substring(-6)}</TableCell>

                      <TableCell>{vehicle.importerStockNumber}</TableCell>

                      <TableCell>{vehicle.year}</TableCell>

                      <TableCell>{vehicle.make}</TableCell>

                      <TableCell>{vehicle.model}</TableCell>

                      <TableCell>{formatDateMoment(vehicle.vehicleCheckInDateTime)}</TableCell>

                      <TableCell>{formatDateMoment(vehicle.ohioTitleApplicationPacketReadyForBuildABoxDateTime)}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </TableContainer>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
